"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.MenuOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M27.25 8.25H4.75V6.25H27.25V8.25Z", fillRule: "evenodd" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M27.25 16.9878H4.75V14.9878H27.25V16.9878Z", fillRule: "evenodd" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M27.25 25.75H4.75V23.75H27.25V25.75Z", fillRule: "evenodd" }))),
        size === 'medium' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M21 5.75H3V4.25H21V5.75ZM21 12.7402H3V11.2402H21V12.7402ZM21 19.75H3V18.25H21V19.75Z", fillRule: "evenodd" }))));
});
exports.MenuOutlined.displayName = 'MenuOutlined';
//# sourceMappingURL=MenuOutlined.js.map